module.exports = __webpack_public_path__ + "static/media/notification.0d062b33.mp3";